import React, {Fragment} from 'react';
import PropTypes from 'prop-types';

const CrumbName = ({currentPage, name, node, positionContent, url, ...rest}) => {
    const aProps = {
        ...(currentPage && {'aria-current': 'page'}),
        className: 'Breadcrumb__a',
        href: url,
        property: 'item',
        typeof: 'WebPage',
        title: name
    };
    const nameSpan = <span property="name" {...rest}>{name}</span>;

    // For the most part, this is assuming `node` is a Link component from react-router-dom.
    // Other use cases' success may vary.  (Note that we don't pass href in link.node as Link uses `to` prop)
    const link = node ? React.cloneElement(node, aProps, nameSpan) : <a {...aProps}>{nameSpan}</a>;

    return (
        <Fragment>
            {(url || node) ? link : <span property="item" typeof="WebPage">{nameSpan}</span>}
            <meta property="position" content={positionContent}/>
        </Fragment>
    );
};

CrumbName.propTypes = {
    name: PropTypes.string.isRequired,
    positionContent: PropTypes.number.isRequired
};

export default CrumbName;
